<template>
  <span class="fraction-wrapper" v-html="renderedText"></span>
</template>

<script>
import { renderFractions } from "@/utils/fractionRenderer";

export default {
  name: "show-fractions",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    renderedText() {
      return renderFractions(this.text || "");
    },
  },
};
</script>

<style>
/* Fraction display styles - centralized here (global styles for v-html content) */
.fraction-wrapper {
  /* Inherit all text styles from parent */
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  text-align: inherit;
  line-height: inherit;
}

.fraction-wrapper .fraction {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
  text-align: center;
  font-size: inherit; /* Changed from 0.9em to inherit */
  margin: 0 2px;
}

.fraction-wrapper .numerator {
  border-bottom: 1px solid currentColor;
  padding-bottom: 1px;
  line-height: 0.9;
  font-size: 0.9em; /* Slightly smaller for better proportion */
}

.fraction-wrapper .denominator {
  padding-top: 1px;
  line-height: 0.9;
  font-size: 0.9em; /* Slightly smaller for better proportion */
}

.fraction-wrapper .mixed-fraction {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin: 0 2px;
}

.fraction-wrapper .whole {
  font-size: inherit; /* Inherit parent font size */
  font-weight: inherit;
}
</style>
